<template>
  <swiper
      class="slider-tabs trade-tabs"
      :slides-per-view="'auto'"
      :space-between="16"
      :slide-to-clicked-slide="true"
      :breakpoints="{
        '576': {
          spaceBetween: 32,
        },
        '1200': {
          spaceBetween: 64,
        },
      }"
  >
    <swiper-slide v-for="tab in tabs" :key="tab.value">
      <button
          type="button"
          class="slider-tabs__tab"
          :class="{ active: modelValue === tab.value }"
          @click="select(tab.value)"
      >
        {{ tab.label }}
        <span class="trade-tabs__count">{{ counts[tab.value] ?? 0 }}</span>
      </button>
    </swiper-slide>
  </swiper>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

const props = defineProps({
  modelValue: {
    type: String,
    default: 'all',
  },
  counts: {
    type: Object,
    default: () => ({ all: 0, auctions: 0, buynow: 0 }),
  },
});

const emit = defineEmits(['update:modelValue']);

const tabs = [
  { value: 'all', label: 'Все лоты' },
  { value: 'auctions', label: 'Аукционы' },
  { value: 'buynow', label: 'Купить сейчас' },
];

const select = (value) => {
  if (value === props.modelValue) return;
  emit('update:modelValue', value);
};
</script>

<style scoped>
.trade-tabs {
  margin-bottom: 1.6rem;
}

.trade-tabs__count {
  display: inline-block;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 10px;
  background: #e6e7e7;
  color: #4b4b4b;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  vertical-align: middle;
  transition: background-color .3s ease, color .3s ease;
}

.slider-tabs__tab.active .trade-tabs__count {
  background: #fc6337;
  color: #fff;
}
</style>
